import {
  Address,
  addressSchema,
  LocalAddress,
  createRequiredLatinCharacterSchema
} from '@/common'
import { z } from 'zod'

const organizationContactFields = {
  contactName: z.string().min(1),
  contactPhoneNumber: z.string().min(1),
  contactEmail: z.email()
}

const organizationDetailsFields = {
  organizationName: createRequiredLatinCharacterSchema(
    'Organization name must use Latin characters',
    { min: 2 }
  ),
  localName: z.string().min(2),
  placeOfRegistration: z.string().length(2),
  businessRegistrationNumber: z.string().min(1).optional(),
  certificateFileName: z.string().optional()
}

export type OrganizationAddress = Address
export type OrganizationLocalAddress = LocalAddress
export type OrganizationContact = z.infer<typeof organizationContactSchema>
export type OrganizationDetails = z.infer<typeof organizationDetailsSchema>

export const organizationAddressSchema = addressSchema
export const organizationContactSchema = z.object(organizationContactFields)
export const organizationDetailsSchema = z.object(organizationDetailsFields)
